import React from 'react'
import PropTypes from 'prop-types'

import BasicViewComponent from './BasicViewComponent'

class Text extends BasicViewComponent {

  constructor (props) {
    super(props)
    this.id = Math.random().toString(36).substr(2, 5)
  }

  render () {
    if (!super.conditionsAreMet()) {
      return null
    }

    let textString = this.evalConfigValue(this.props.config.text)
    if (!textString) {
      return null
    }

    const texts = textString.split('\n').reduce((acc, val, index) => {
      if (index > 0) {
        acc.push(<br key={`${this.id}_${index}_br`}/>)
      }

      acc.push(<span key={`${this.id}_${index}`}>{val}</span>)
      return acc
    }, [])

    const href = this.props.config.href ? this.evalConfigValue(this.props.config.href) : null

    if (href) {
      if (window.KesiTools) {
        return (
          <a
            className={this.cssClass}
            onClick={() => window.KesiTools.openWebsiteInSystemBrowser(href)}
          >
            {texts}
          </a>
        )
      }
      else {
        const target = href ? '_blank' : ''
        return (
          <a
            className={this.cssClass}
            href={href}
            target={target}
          >
            {texts}
          </a>
        )
      }
    }

    return (
      <span
        className={this.cssClass}
        onTouchTap={this.onTouchTap}
      >
        {texts}
      </span>
    )

  }

}

Text.TYPE = 'text'

Text.propTypes = {
  config: PropTypes.object.isRequired,
}

export default Text



// WEBPACK FOOTER //
// ./src/components/ViewComponents/Text.js